<h3>{{product?.title}}</h3>
<h4>{{product?.subtitle}}</h4>
<span *ngIf="product?.image?.endsWith('.svg'); else image" class="image" [inlineSVG]="product?.image"></span>
<ng-template #image>
  <img class="image" [src]="product?.image" [alt]="product?.title">
</ng-template>
<img class="logo" [src]="product?.logo" alt="Logo" *ngIf="product?.logo">
<div class="content">
  <p class="initial" [class.fixed-top]="!product?.subtitle" *ngIf="product?.content">{{product?.content}}</p>
  <div class="expanded" *ngIf="product?.expandedList">
    <ng-container *ngFor="let item of product?.expandedList; let last = last;">
      <div class="item">
        <span [ngClass]="item.color ? item.color : 'mango-tint-60'" [inlineSVG]="item.icon"></span>
        <p>{{item.content}}</p>
      </div>
      <div class="divider" *ngIf="!last"></div>
    </ng-container>
  </div>
</div>
<div class="handle" *ngIf="product?.expandedList" (click)="expanded = !expanded">
  <span inlineSVG="/assets/home/product/chevron.svg"></span>
</div>
